/**
 * StickerUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StickerUpdateReq
 */
export interface StickerUpdateReq {
  /** 表情包ID */
  id: string
  /** 表情标题 */
  title?: string
  /** 表情类型 */
  type?: string
  /** 表情来源 */
  source?: string
  /** 表情描述 */
  description?: string
  /** 标签列表（逗号分隔） */
  tags?: string
  /** 表情文件ID */
  file_id?: any
  /** 创建用户ID */
  creator_id?: any
}

/**
 * StickerUpdateReq Schema
 */
export const StickerUpdateReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '表情包ID',
      format: 'string',
      type: 'string',
      label: '表情包ID',
    },
    title: {
      description: '表情标题',
      format: '*string',
      maxLength: 100,
      minLength: 1,
      type: 'string',
      label: '表情标题',
    },
    type: {
      description: '表情类型',
      format: '*cons.StickerType',
      type: 'string',
      label: '表情类型',
    },
    source: {
      description: '表情来源',
      format: '*cons.StickerSource',
      type: 'string',
      label: '表情来源',
    },
    description: {
      description: '表情描述',
      format: '*string',
      maxLength: 200,
      type: 'string',
      label: '表情描述',
    },
    tags: {
      description: '标签列表（逗号分隔）',
      format: '*string',
      maxLength: 500,
      type: 'string',
      label: '标签列表',
    },
    file_id: {
      description: '表情文件ID',
      format: '*string',
      type: 'file',
      label: '表情文件ID',
    },
    creator_id: {
      description: '创建用户ID',
      format: '*string',
      type: 'user',
      label: '创建用户ID',
    },
  },
  required: ['id'],
  type: 'object',
}
